<template>
  <div class="takingPicturesIntegral">
    <div class="amount-container">
      <md-field title="请输入金额(元)">
        <div class="field-operator" slot="action" @click="onClick">
          <md-icon name="info"></md-icon>
        </div>
        <md-input-item
          type="money"
          v-model="code"
          placeholder=""
          size="large"
          is-amount
          is-highlight
        >
          <div class="input-operator" slot="left">￥</div>
        </md-input-item>
        <!-- <md-input-item v-model="imageName" placeholder="请输入图片名称" :is-title-latent="true"></md-input-item> -->
      </md-field>
    </div>
    <div class="update-container">
      <div class="update-btn">
        <label for="avatar">请上传小票及消费凭证:</label>
        <!-- <input type="file" ref="file" id="avatar" name="avatar" accept="image/*" @change='upLoadImg($event)'> -->
        <input id="imgUpload" type="file" @change="addPic" accept="image/*"/>
         <!-- style='display:none'
        <p>
          <label for="imgUpload">上传</label>
        </p> -->
      </div>
      <div class="show-img">
        <img ref="portrait" src="" width="100%" height="120">
        <progress ref="Progress" value="0" max="100" v-show='isprogress'></progress>
      </div>
    </div>
    <div class="btn-container">
      <md-button :type="btnType" :loading='btnloading' class="btn" @click="submitFn">提交</md-button>
      <!-- <md-button type="default" class="btn">客服电话</md-button> -->
      <p class="p"  @click="goToIntegralRecord">查看积分记录</p>
    </div>
    <ul class="some-msg" v-if='integralRules.length'>
      <div class="title">积分规则：</div>
      <li class='msg-item' v-for='item in integralRules' :key='item'>
        <p>{{item}}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "takingPicturesIntegral",
  data() {
    return {
      btnType:'primary',
      btnloading:false,
      code: "",
      // imageName: "",
      isprogress:false,
      imgId:'',
      imgFile:'',
      integralRules : [
        // '1、请将清晰、完整的专柜消费小票拍照上传（无商户名、无商户盖章、交易日期、交易单号、小票金额）视为非完整小票。',
        // '2、一张消费小票只能补一次积分，如您有多张小票，请分开拍照提交。',
        // '3、服饰、餐饮、文娱1元积1分。',
        // '4、珠宝、名表10元积1分。',
        // '5、积分使用暂时仅限于“积分停车”，100积分=1元。',
        // '6、积分将于2个工作日调整生效 节假日顺延。',
        // '7、如有疑问请拨打客服电话：0371-65001666'
      ]
    };
  },
  mounted() {
    document.title = "拍照积分";
  },
  computed: {
    size() {
      return this.code.length > 10 ? "small" : "large";
    }
  },
  methods: {
    onClick() {
      this.UI.Toast.info("请输入票据总金额");
    },
    //获取图片
    addPic(e){
      if (typeof FileReader === 'undefined') {
        this.UI.Toast.failed('你的手机不支持上传图片哟！')
        return 
      }
      var files = e.target.files || e.dataTransfer.files;
      if(files.length > 0){
        this.imgFile = files[0];
        this.imgResize(files[0], this.callback);
      }
    },
    //图片压缩
    imgResize(file, callback){
      let _this = this;
      var fileReader = new FileReader();
      fileReader.onload = function(){
        var IMG = new Image();
        IMG.src = this.result;
        IMG.onload = function(){
          var w = this.naturalWidth, h = this.naturalHeight, resizeW = 0, resizeH = 0;
          // maxSize 是压缩的设置，设置图片的最大宽度和最大高度，等比缩放，level是报错的质量，数值越小质量越低
          var maxSize = {
            width: 1440,
            height: 1080,
            level: .9
          };
          if(w > maxSize.width || h > maxSize.height){
            var multiple = Math.max(w / maxSize.width, h / maxSize.height);
            resizeW = w / multiple;
            resizeH = h / multiple;
            // console.log('2')
          } else {
            // console.log('1')
            // 如果图片尺寸小于最大限制，则不压缩直接上传
            return callback(file)
          }
          var canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');
          // if(window.navigator.userAgent.indexOf('iPhone') > 0){
          //   canvas.width = resizeH;
          //   canvas.height = resizeW;
          //   ctx.rotate(90 * Math.PI / 180);
          //   ctx.drawImage(IMG, 0, -resizeH, resizeW, resizeH);
          // }else{
            canvas.width = resizeW;
            canvas.height = resizeH;
            ctx.drawImage(IMG, 0, 0, resizeW, resizeH);
          // }
          var base64 = canvas.toDataURL('image/jpeg', maxSize.level);
          // console.log('base64',base64)
          _this.convertBlob(window.atob(base64.split(',')[1]), callback);
        }
      };
      fileReader.readAsDataURL(file);
    },
    //base64转流数据
    convertBlob(base64, callback){
      var buffer = new ArrayBuffer(base64.length);
      var ubuffer = new Uint8Array(buffer);
      for (var i = 0; i < base64.length; i++) {
        ubuffer[i] = base64.charCodeAt(i)
      }
      var blob;
      try {
        blob = new Blob([buffer], {type: 'image/*'});
      } catch (e) {
        window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
        if(e.name === 'TypeError' && window.BlobBuilder){
          var blobBuilder = new BlobBuilder();
          blobBuilder.append(buffer);
          
          blob = blobBuilder.getBlob('image/*');
        }
      }
      callback(blob)
    },
    //图片上传
    callback(fileResize){
      // console.log(fileResize)
      let files = new window.File([fileResize], this.imgFile.name, {type: this.imgFile.type})
      let param = new FormData();
      param.append('file', files);
      param.append('fileClass','PICTURES_OF_INTEGRAL');//通过append向form对象添加数据
      // console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers:{
          'Content-Type':'multipart/form-data'
        },
      }; //添加请求头
      this.btnloading = true;
      this.btnType ='disabled';
      this.$http
        .post("/fileserver/file/upload",param,config)
        .then( res => {
          res = JSON.parse(JSON.stringify(res.data));
          if(res.code == 200){
            this.btnloading = false;
            this.btnType ='primary';
            this.imgId  = res.data.id;
            this.UI.Toast.succeed('图片上传成功')  //成功
          }else{
            this.UI.Toast.failed(res.message)
          }
        });
      //预览和进度条
      if(window.FileReader) {
          var fr = new FileReader();
          fr.onloadend = (e)=> {
              this.$refs.portrait.src = e.target.result;
          };
          //给FileReader对象一个读取完成的方法,使用readAsDataURL会返回一个url,这个值就保存在事件对象的result里,img通过加载这个地址,完成图片的加载
          fr.readAsDataURL(files);
      }
      let total =  files.size;
      fr.onprogress = (ev) =>{
          this.isprogress = true;
          // 简单测试了一下 大概12M左右的传输速度
          // 推荐测试的时候用一个视频
          // console.log(ev.loaded / total);
          let loading = (ev.loaded / total)*100;
          this.$refs.Progress.value = loading;
      }
    },
    // upLoadImg(e){
    //   let file = e.target.files[0];
      
    //   if(file.size /1000 > 1024 * 10 ){
    //     this.UI.Toast.failed('上传图片不能大于10M！')
    //     return
    //   }
    //   let param = new FormData(); //创建form对象
    //   param.append('file',file);//通过append向form对象添加数据
    //   param.append('fileClass','PICTURES_OF_INTEGRAL');//通过append向form对象添加数据
    //   console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
    //   let config = {
    //     headers:{
    //       'Content-Type':'multipart/form-data'
    //     },
    //     timeout: 30 * 1000
    //   }; //添加请求头
    //   this.btnloading = true;
    //   this.btnType ='disabled';
    //   this.$http
    //     .post("/fileserver/file/upload",param,config)
    //     .then( res => {
    //       res = JSON.parse(JSON.stringify(res.data));
    //       if(res.code == 200){
    //         this.btnloading = false;
    //         this.btnType ='primary';
    //         this.imgId  = res.data.id;
    //       }else{
    //         this.UI.Toast.failed(res.message)
    //       }
    //     });
    //   //预览和进度条
    //   if(window.FileReader) {
    //       var fr = new FileReader();
    //       fr.onloadend = (e)=> {
    //           this.$refs.portrait.src = e.target.result;
    //       };
    //       //给FileReader对象一个读取完成的方法,使用readAsDataURL会返回一个url,这个值就保存在事件对象的result里,img通过加载这个地址,完成图片的加载
    //       fr.readAsDataURL(file);
    //   }
    //   let total =  e.target.files[0].size;
    //   fr.onprogress = (ev) =>{
    //       this.isprogress = true;
    //       // 简单测试了一下 大概12M左右的传输速度
    //       // 推荐测试的时候用一个视频
    //       // console.log(ev.loaded / total);
    //       let loading = (ev.loaded / total)*100;
    //       this.$refs.Progress.value = loading;
    //   }
    // },
    submitFn(){
      if (!this.code){
        this.UI.Toast.failed('金额不能为空') 
        return
      }else{
        let exr = /^[1-9]\d{0,10}(?:\.\d{0,2})?$/
        if(!exr.test(this.code)){
          this.UI.Toast.failed('请输入1~10位整数可保留2位小数') 
          return
        }
      }
      // if(!this.imageName){
      //   this.UI.Toast.failed('图片名称不能为空') 
      //   return
      // }
      if (!this.imgId){
        this.UI.Toast.failed('请先上传图片') 
        return
      }
      
      this.btnloading = true;
      this.btnType ='disabled';
      this.sendDataFn();
    },
    sendDataFn(){
      let data = JSON.parse(localStorage.getItem('userData'))
      let dt = new URLSearchParams();
      dt.append('imgId',this.imgId)
      dt.append('cardAccount',data.cardAccount)
      dt.append('money',this.code)
      this.$http
        .post("/sangto-wrm/vipScoreOther/addImg", dt)
        .then(res => {
          res = res.data;
          // console.log('res=:',JSON.stringify(res))
          if(res.code == "200" && res.data){
            this.UI.Toast.succeed('提交成功！')
          }else{
            this.UI.Toast.failed(res.message) 
          }
          this.$refs.portrait.src = '';
          this.$refs.Progress.value = 0;
          // this.$refs.file.value = '';
          this.isprogress = false;
          this.code = '';
          this.imgId = '';
          this.btnloading = false;
          this.btnType ='primary';
        });
    },
    goToIntegralRecord(){
      this.$router.push({name:'integralRecord'});
    }
  }
};
</script>
<style lang="scss" scoped>
.takingPicturesIntegral {
  width: 100%;
  height: 100%;
  background: #fff;
  & .amount-container {
    padding:20px;
    padding-bottom:0;
    .input-operator{
      font-size:32px;
    }
  }
  & .update-container {
    padding: 0 2rem;
    border-bottom: 1px solid #eee;
    & .update-btn{
      margin: 10px 0;
    }
    & .show-img {
      display: flex;
      flex-direction: column;
      padding-bottom:15px;

      // img {
      //   height: 100%;
      //   width: 80px;
      // }
      progress {
        width:100%;
        margin-top:10px;
        border: 1px solid #405f80;  
        background-color:#efefef;
        color: #405f80; /*IE10*/
      }
      progress::-moz-progress-bar { background: #0064B4; }
      progress::-webkit-progress-bar { background: #e6e6e6; }
      progress::-webkit-progress-value  { background: #0064B4; }
    }
  }
  & .btn-container {
    height: 100px;
    padding: 30px;
    & .btn {
      margin-bottom: 15px;
    }
    & .p {
      text-decoration: underline;
      color: #2f86f6;
      text-align: center;
      margin-bottom:30px;
    }
  }
  & .some-msg{
    margin-bottom:20px;
    padding-top:40px;
    & .title{
      font-size:16px;
      font-weight: 900;
      text-align: left;
      text-indent: 20px;
      line-height:30px;
    }
    & .msg-item{
      line-height: 40px;
      font-size:14px;
      text-align: left;
      margin:auto 20px;
      & p{
        display: inline-block;
        line-height:20px;
        vertical-align: middle;
      }
    }
  }
}
</style>
